// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"error-message_errorMessage__YZWTd","errorMessageIcon":"error-message_errorMessageIcon__kH6EC","errorMessageText":"error-message_errorMessageText__k1dsl"};